import { UserRoles } from "../enums/UserRoles"

export class UserModel {
    id:string = ''
    name:string = ''    
    username:string = ''    
    email:string = ''    
    emailVerified:boolean = false
    roles: UserRoles[] = []

    constructor(u?:Partial<UserModel>) {
        Object.assign(this, u)
    }

    hasRoleAdmin():boolean {
        return this.roles.includes(UserRoles.Administrator)
    }

    hasRoleSellerOperator():boolean {
        return this.roles.includes(UserRoles.SellerOperator)
    }

    hasRoleBiller():boolean {
        return this.roles.includes(UserRoles.Biller)
    }

    hasRoleOperator():boolean {
        return this.roles.includes(UserRoles.Operator)
    }

    hasRoleSupport():boolean {
        return this.roles.includes(UserRoles.Support)
    }
}
